import React, {
  useEffect,
  useMemo,
} from 'react'

import PropTypes from 'prop-types'

import ModalDialog from './ModalDialog'
import ModelessDialog from './ModelessDialog'

import { useIsModeless } from './IsModelessContext'

import Styles from './styles.scss'

// TODO: why is this not in the stylesheet?
const MODAL_CONTENT_STYLES = {
  'modal-xl': {
    margin: '3% auto 20px',
    opacity: '1',
  },
  'modal-md': {
    margin: '3% auto 20px',
    opacity: '1',
  },
  'consent-banner': {
    opacity: '1',
  },
}


export default function Dialog({ ariaLabel, children, fixedBody, handleCancel, modalStyle, uiType }) {
  const isModeless = useIsModeless()

  useEffect(() => {
    if ( !fixedBody ) {
      return
    }

    document.body.classList.add(Styles.preventBodyScroll)

    return () => {
      document.body.classList.remove(Styles.preventBodyScroll)
    }
  }, [fixedBody])

  const backgroundStyle = useMemo(() => {
    const styles = {
      ...MODAL_CONTENT_STYLES[uiType],
    }

    if ( modalStyle?.background ) {
      styles.background = modalStyle.background
    }

    return styles
  }, [modalStyle, uiType])

  const content = (
    <div
      className={ Styles[uiType] }
      style={ backgroundStyle }
    >
      { children }
    </div>
  )

  if ( isModeless ) {
    return (
      <ModelessDialog>
        { content }
      </ModelessDialog>
    )
  }

  return (
    <ModalDialog
      ariaLabel={ ariaLabel }
      handleCancel={ handleCancel }
    >
      { content }
    </ModalDialog>
  )
}

Dialog.propTypes = {
  uiType: PropTypes.oneOf(
    Object.keys(MODAL_CONTENT_STYLES)
  ).isRequired,

  ariaLabel: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  fixedBody: PropTypes.bool,
  handleCancel: PropTypes.func,
  modalStyle: PropTypes.shape({
    background: PropTypes.string,
  }),
}
